import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { LzProductConfig } from '../product-config/poduct-config';

declare var $: any;
declare var Fingerprint: any;
declare var fingerprint_useragent: any;
declare var fingerprint_os: any;
declare var fingerprint_browser: any;

@Injectable()

export class ErrorLogService {

      private lang: string;
      private rnd: string;
      private fingerprint: string;
      private headers: HttpHeaders = new HttpHeaders();

      private isDataCollected = false;
      private disableLogging = false;
      private userEmail = '';
      private userData = {
            'productName': '',
            'productVersion': '',
            'productAlias': '',
            'userOs': '',
            'userAgent': '',
            'userBrowser': '',
            'googleAnaliticsId': '',
            'fingerprint': ''
      };

      private configData: any;

      constructor(private config: LzProductConfig, private http: HttpClient) {

            this.configData = config.getProductSettings();

            try {
                  this.userData['fingerprint'] = new Fingerprint({
                        screen_resolution: true
                  }).get();
            } catch (e) {
                  this.userData['fingerprint'] = '';
            }
            this.fingerprint = this.userData['fingerprint'];

            this.lang = 'ru';

            this.rnd = '' + (+new Date() + '.' + this.fingerprint);

            this.headers = this.headers
               .set('Content-Type', 'application/json; charset=utf-8')
               .set('Accept-Language', this.lang)
               .set('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT')
               .set('Cache-Control', 'no-cache, no-store, must-revalidate')
               .set('Pragma', 'no-cache');
      }

      private getUserAgent = () => {
            try {
                  this.userData['userAgent'] = fingerprint_useragent();
            } catch (e) {
                  this.userData['userAgent'] = ''
            }
      }

      private getProductName = () => {
            try {
                  this.userData['productName'] = (this.configData['product_name']) ? this.configData['product_name'] : '';
            } catch (e) {
                  this.userData['productName'] = '';
            }
      }

      private getProductAlias = () => {
            try {
                  this.userData['productAlias'] = (this.configData['order_code']) ? this.configData['order_code'] : '';
            } catch (e) {
                  this.userData['productAlias'] = '';
            }
      }

      private getProductVersion = () => {
            try {
                  this.userData['productVersion'] = (this.configData['product_version']) ? this.configData['product_version'] : '';
            } catch (e) {
                  this.userData['productVersion'] = '';
            }
      }

      private getUserGoogleId = () => {
            try {
                  let match = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)');
                  let raw = (match) ? decodeURIComponent(match[1]) : null;
                  if (raw) {
                        match = raw.match(/(\d+\.\d+)$/);
                  }
                  let gacid = (match) ? match[1] : null;
                  if (gacid) {
                        this.userData['googleAnaliticsId'] = gacid;
                  } else {
                        this.userData['googleAnaliticsId'] = '';
                  }
            } catch (e) {
                  this.userData['googleAnaliticsId'] = '';
            }
      }

      private getUserOs = () => {
            try {
                  this.userData['userOs'] = fingerprint_os();
            } catch (e) {
                  this.userData['userOs'] = '';
            }
      }

      private getUserBrowser = () => {
            try {
                  this.userData['userBrowser'] = fingerprint_browser();
            } catch (e) {
                  this.userData['userBrowser'] = '';
            }
      }

      private log = (data) => {

            try {
                  data.chalk = '';
                  let sToEncrypt = '';

                  for (let key in this.userData) {
                        if(this.userData[key]) {
                          sToEncrypt += encodeURI(key + '=' + this.userData[key] + '&');
                        }
                  }

                  if(sToEncrypt && sToEncrypt.length > 0) {
                    sToEncrypt = sToEncrypt.replace(/.$/, ''); // .$ - any character at the end of a string
                    data.chalk = this.encryptStringWithXORtoHex(sToEncrypt, 'required output');
                  }
            } catch (e) { }

            if (this.userData['productName'] && this.userData['productName'].length > 0) {
                  $.ajax({
                        url: this.config.getApiLink() + '/usererror/' + encodeURI(this.userData['productName']) + '/' + ((this.userEmail) ? this.userEmail : 'undefined') + '/' + 'error_' + encodeURI(this.userData['productName']),
                        type: "POST",
                        data: data || {}
                  });
            }

      }

      private getUserInfo(callback): any {
            return this.http.get(this.config.getApiLink() + '/lz-platforma/user/v1.0/userInfo?' + this.rnd, {
                  headers: this.headers,
                  withCredentials: true
            }).subscribe((msg: any) => {
              callback(msg);
            }, (errMSG) => {
              callback({email: 'undefined'})
            });
      }

      private encryptStringWithXORtoHex = (input, key) => {
        var c = '';
        while (key.length < input.length) {
            key += key;
        }
        for(var i=0; i<input.length; i++) {
            var value1 = input[i].charCodeAt(0);
            var value2 = key[i].charCodeAt(0);

            var xorValue = value1 ^ value2;

            var xorValueAsHexString = xorValue.toString(16);

            if (xorValueAsHexString.length < 2) {
                xorValueAsHexString = "0" + xorValueAsHexString;
            }

            c += xorValueAsHexString;
        }
        return c;
    }


      public errorLogForSpark = (data) => {

            if (this.disableLogging) {
                  return;
            }

            if (!this.isDataCollected) {
                  this.getUserAgent();
                  this.getProductVersion();
                  this.getProductName();
                  this.getProductAlias();
                  this.getUserGoogleId();
                  this.getUserOs();
                  this.getUserBrowser();
                  this.isDataCollected = true;
            }

            if (!this.userData['productAlias'] && !this.userData['productName']) {
                  this.disableLogging = true;
                  return;
            }

            if (this.userEmail !== '') {
                  this.log(data);
            } else {
                  this.getUserInfo((info) => {
                        this.userEmail = info.email;
                        if (!this.userEmail) {
                              this.userEmail = 'undefined';
                        }
                        this.log(data);
                  });
            }
      }

}
